module.exports = __webpack_public_path__ + "7360290d2b654c7a11c000f9a0b7350e.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-LightItalic.eot
// module id = 703
// module chunks = 0